import type { FunctionComponent } from 'react';
import loadable from '@loadable/component';
import { SubSubSectionHeader } from '@/components/CompanyOverview/components/SubSubSectionHeader';
import PriceVolatilityTable from './components/PriceVolatilityTable';
import ChartWrapper from '@/components/CompanyOverview/components/ChartWrapper';
import { GraphWrapper } from './styled';
import { useSelector, shallowEqual } from 'react-redux';
import { selector } from './selector';

const PriceVolatilityMarketGraph = loadable(
  () => import('./components/PriceVolatilityMarketGraph'),
  { ssr: false }
);

interface Props {
  country: string;
  industry: string;
  tickerSymbol: string;
  companyName?: string;
  feedbackLabel?: string;
}

const PriceVolatilityMarket: FunctionComponent<Props> = ({
  country,
  industry,
  tickerSymbol,
  companyName,
  feedbackLabel,
}) => {
  const data = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);
  return (
    <>
      <SubSubSectionHeader>Price Volatility</SubSubSectionHeader>
      <ChartWrapper
        id="overview-price-volatility"
        chart={
          <GraphWrapper data-cy-id="price-volatility-chart">
            <PriceVolatilityMarketGraph
              country={country}
              industry={industry}
              tickerSymbol={tickerSymbol}
              marketValue={data.market}
              companyValue={data.company}
              industryValue={data.industry}
              companyVolatility={data.companyFormatted}
              industryVolatility={data.industryFormatted}
              marketVolatility={data.marketFormatted}
              min={data.marketP10}
              max={data.marketP90}
            />
          </GraphWrapper>
        }
        table={
          <GraphWrapper>
            <PriceVolatilityTable
              tickerSymbol={tickerSymbol}
              industry={industry}
              country={country}
              companyVolatility={data.companyFormatted}
              industryVolatility={data.industryFormatted}
              marketVolatility={data.marketFormatted}
              marketVolatilityP10={data.marketP10Formatted}
              marketVolatilityP90={data.marketP90Formatted}
            />
          </GraphWrapper>
        }
        preRenderHeight={224}
        preRenderHeightSmDown={180}
        companyName={companyName}
        feedbackLabel={feedbackLabel}
      />
    </>
  );
};

export default PriceVolatilityMarket;
